module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-modal"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": 'https://www.youtube.com/embed/' + _vm.$store.state.videoModalSrc,
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aa39898"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoModal.vue
// module id = 301
// module chunks = 0